/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthChallengeRequest as ModelsAuthenticationAuthChallengeRequest } from '../../models/Models/Authentication/auth-challenge-request';
import { AuthChallengeResponse as ModelsAuthenticationAuthChallengeResponse } from '../../models/Models/Authentication/auth-challenge-response';

export interface V3TokenAuthorizePost$Json$Plain$Params {
      body?: ModelsAuthenticationAuthChallengeRequest
}

export function v3TokenAuthorizePost$Json$Plain(http: HttpClient, rootUrl: string, params?: V3TokenAuthorizePost$Json$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>> {
  const rb = new RequestBuilder(rootUrl, v3TokenAuthorizePost$Json$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAuthenticationAuthChallengeResponse>;
    })
  );
}

v3TokenAuthorizePost$Json$Plain.PATH = '/v3/token/authorize';
